module.exports = __webpack_public_path__ + "img/fi-water-side-rest-600x395.6d9a2e1a.jpg";